import { plural } from '@lingui/core/macro';
import moment from 'moment';

import getDefaultPetCounts from '@rover/shared/js/utils/getDefaultPetCounts';

export const isSameDay = (startDate?: Date, endDate?: Date): boolean =>
  !!startDate && !!endDate && startDate.getTime() === endDate.getTime();

export const daysFromToday = (date: Date): number =>
  moment(date).startOf('day').diff(moment().startOf('day'), 'days');

/**
 * Given a dog, puppy, and cat count, returns a string formatted for display in the header.
 */
export const getFormattedPetData = ({
  dogCount: originalDogCount = 0,
  puppyCount: originalPuppyCount = 0,
  catCount: originalCatCount = 0,
}): string[] => {
  const petDescriptors: string[] = [];
  const { dogCount, catCount, puppyCount } = getDefaultPetCounts({
    dogCount: originalDogCount,
    puppyCount: originalPuppyCount,
    catCount: originalCatCount,
  });

  if (dogCount) {
    petDescriptors.push(
      plural(dogCount, {
        one: '# dog',
        other: '# dogs',
      })
    );
  }

  if (puppyCount) {
    petDescriptors.push(
      plural(puppyCount, {
        one: '# puppy',
        other: '# puppies',
      })
    );
  }

  if (catCount) {
    petDescriptors.push(
      plural(catCount, {
        one: '# cat',
        other: '# cats',
      })
    );
  }

  return petDescriptors;
};
